export default {
  getCustomStatuses: state => state.customStatuses
}
